export default __webpack_public_path__ + "static/media/pipe-pliers.a70ea55e.svg";